import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Family } from '../_models/family';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class FamilyService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getRessourceByTypeCode(ressourceCode: string) {
    return this.http.get<Family[]>(`${environment.apiUrl}/Family/OwnFamilies?ressourceCode=${ressourceCode}`, { headers: this.authService.headers });
  }

  getFamily(familyId: string) {
    return this.http.get<Family>(`${environment.apiUrl}/Family/${familyId}`, { headers: this.authService.headers }).toPromise();
  }

  editFamily(family: Family) {
    return this.http.put<Family>(`${environment.apiUrl}/Family/${family?.familyId}`, family, { headers: this.authService.headers }).toPromise();
  }

  addFamily(family: Family, typeCode: string) {
    return this.http.post<Family>(`${environment.apiUrl}/Family?typeCode=${typeCode}`, family, { headers: this.authService.headers }).toPromise();
  }

  deleteFamily(familyId: string) {
    return this.http.delete<Family>(`${environment.apiUrl}/Family/${familyId}`, { headers: this.authService.headers }).toPromise();
  }
}
